/*
 * Résolution des polices.
 *
 * La table syn_font ne stocke que des noms PostScript natifs iOS/Android
 * ("HelveticaNeue-Bold", "Arial-BoldMT", "Roboto-CondensedLight"...). En CSS,
 * font-family matche des noms de FAMILLE, pas des noms PostScript : utilisés
 * tels quels ces noms ne matchent rien et le navigateur retombe sur sa police
 * par défaut.
 *
 * resolveFont() traduit un name_web en pile CSS + graisse + style. La graisse
 * et l'italique sont déduits du nom et non des colonnes is_bold / is_italic,
 * qui sont fausses sur plusieurs lignes (les variantes "Oblique" ont
 * is_italic = 0, "RobotoCondensed-Light" a is_italic = 1).
 */

// Les 6 familles réellement présentes en base, triées du préfixe le plus long
// au plus court : "robotocondensed" doit matcher avant "roboto", et
// "helveticaneue" avant "helvetica".
const FAMILIES = [
    {key: "robotocondensed", stack: '"Roboto Condensed", "Helvetica Neue", Helvetica, Arial, sans-serif'},
    {key: "helveticaneue", stack: '"Helvetica Neue", Helvetica, Roboto, Arial, sans-serif'},
    {key: "helvetica", stack: 'Helvetica, "Helvetica Neue", Roboto, Arial, sans-serif'},
    {key: "verdana", stack: 'Verdana, Geneva, "DejaVu Sans", sans-serif'},
    {key: "arialmt", stack: 'Arial, Helvetica, Roboto, sans-serif'},
    {key: "arial", stack: 'Arial, Helvetica, Roboto, sans-serif'},
    {key: "roboto", stack: 'Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif'},
];

export const DEFAULT_FONT_STACK = 'Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif';

const WEIGHTS = {
    thin: 100,
    ultralight: 200, extralight: 200,
    light: 300, book: 300,
    regular: 400, normal: 400,
    medium: 500,
    semibold: 600, demibold: 600,
    bold: 700,
    extrabold: 800, ultrabold: 800,
    black: 900, heavy: 900,
};

// Tri par longueur décroissante : "ultralight" doit matcher avant "light" et
// "semibold" avant "bold", sinon la sous-chaîne courte gagne.
const WEIGHT_KEYS = Object.keys(WEIGHTS).sort((a, b) => b.length - a.length);

export function resolveFont(nameWeb) {

    if (!nameWeb) return {};

    let normalized = String(nameWeb).toLowerCase().replace(/[^a-z]/g, "");
    let family = FAMILIES.find((f) => normalized.startsWith(f.key));

    // Ce qui reste après le nom de famille porte la graisse et le style.
    let variant = family ? normalized.slice(family.key.length) : normalized;
    let weightKey = WEIGHT_KEYS.find((k) => variant.includes(k));

    let resolved = {
        fontFamily: family ? family.stack : DEFAULT_FONT_STACK,
        fontWeight: weightKey ? WEIGHTS[weightKey] : 400,
        fontStyle: (variant.includes("italic") || variant.includes("oblique")) ? "italic" : "normal",
    };

    // Police inconnue (saisie libre dans le JSON d'une vue graphique) : on la
    // tente en premier, avec la pile par défaut en secours.
    if (!family) {
        let base = String(nameWeb).split("-")[0].replace(/["';{}]/g, "").trim();
        resolved.fontFamily = base ? '"' + base + '", ' + DEFAULT_FONT_STACK : DEFAULT_FONT_STACK;
    }

    // "HelveticaNeue-CondensedBlack" : la famille reste Helvetica Neue, seule
    // la chasse change. Pour Roboto Condensed la famille est déjà la bonne.
    if (variant.includes("condensed")) {
        resolved.fontStretch = "condensed";
    }

    return resolved;
}